<nb-toggle  [checked]="true" labelPosition="start">About Us</nb-toggle>
<nb-toggle [checked]="true" labelPosition="start">Blog Link</nb-toggle>
<nb-toggle [checked]="true" labelPosition="start">Facebook Link</nb-toggle>
<nb-toggle [checked]="true" labelPosition="start">Twitter Link</nb-toggle>
